import React, { useState } from "react";
import { Modal, message } from "antd";
import {
  IconButton,
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../axiosInstance";

const EditAcademicCalendar = ({id, CalendarName, CalendarEvent, CalendarDate, refreshData}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(CalendarName);
  const [event, setEvent] = useState(CalendarEvent);
    const [date, setDate] = useState(CalendarDate);
  const eventDate = moment(date).format("MM/DD/YYYY");

  // Open modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Close modal
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleStartDateChange = (date) => {
    setDate(date);
  };
  // Confirm dialog from Ant Design
  const { confirm } = Modal;

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    confirm({
      title: "Confirm Edit",
      content: "Are you sure you want to update the exam time table?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        setLoading(true);
        // Prepare data for submission
        const UpdateData = {
          id,
          name,
          event,
          date: eventDate,
        };
        try {
            const { data } = await axios.put(
              "/api/v1/academic-calendar/admin-update",UpdateData,);
            if (data.success === true) {
              message.success(data.message);
              refreshData();
            } else {
              message.error(data?.message);
            }
          } catch (error) {
            message.error(error?.response?.data?.message);
          } finally {
            setLoading(false);
          }
        setIsModalOpen(false);
      },
    });
  };

  return (
    <>
      <IconButton aria-label="edit" onClick={showModal}>
        <EditIcon sx={{ color: "#1976d2" }} />
      </IconButton>

      <Modal
        title="Edit Academic Exam Time Table"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null} // No default footer buttons
      >
        <Container
          component="form"
          onSubmit={handleSubmit}
          className="form_style border-style"
        >
          <h4>Event Name</h4>
                   <FormControl fullWidth sx={{ mb: 3, mt:1}}>
                     <InputLabel id="event-name-label">Event Name *</InputLabel>
                     <Select
                       labelId="event-name-label"
                       id="EventName"
                       name="eventName"
                       value={name}
                       onChange={(e) => setName(e.target.value)}
                       label="Event Name *"
                     >
                       <MenuItem value="All">All</MenuItem>
                       <MenuItem value="School">School</MenuItem>
                       <hr />
                       <MenuItem value="RIMC">RIMC</MenuItem>
                       <MenuItem value="Navodaya">Navodaya</MenuItem>
                       <MenuItem value="Sainik">Sainik</MenuItem>
                       <MenuItem value="Military">Military</MenuItem>
                     </Select>
                   </FormControl>
         
                   <h4>Event Description </h4>
                   <ReactQuill
                     value={event}
                     onChange={setEvent}
                     placeholder="Event"
                     style={{
                       // height: "200px",
                       marginBottom: "30px",
                       border: "1px solid rgba(0,0,0,0.1)",
                       borderRadius: "10px",
                     }}
                   />
         
                   <Box className="Date">
                     <Box sx={{ mt: 3 }}>
                       <h4>Event Date</h4>
                       <DatePicker
                         showIcon
                         toggleCalendarOnIconClick
                         isClearable
                         placeholderText="Event Date"
                         selected={date}
                         onChange={handleStartDateChange}
                         minDate={new Date()}
                         maxDate={date}
                         value={date}
                       />
                     </Box>
                   </Box>
         
                   <Button
                     type="submit"
                     variant="contained"
                     color="primary"
                     className="courses_desc"
                     sx={{
                       mt: 3,
                       borderRadius: "5px",
                       textTransform: "none",
                       fontFamily: "Poppins, sans-serif",
                       letterSpacing: ".1rem",
                     }}
                   >
                     Update Event
                   </Button>

        </Container>
      </Modal>
    </>
  );
};

export default EditAcademicCalendar;
